import * as React from 'react';
import { Typography } from '../../Typography';

import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { handleLinkClick } from '../../../utils/linkHandler';

type TLink = {
  name: string;
  href: string;
};

export const LinkItem: React.FC<TLink> = link => {
  const deviceType = useDeviceType();

  return (
    <a
      className={cn(styles['link'], styles[deviceType])}
      onClick={e => {
        handleLinkClick(e, link.href);
      }}
      href={link.href}
    >
      <Typography.Text color="currentColor" level={3} fontWeight={'bold'}>
        {link.name}
      </Typography.Text>
    </a>
  );
};
